import { ENV_URL } from 'constants/env';

export const API = `${ENV_URL}/app`;

export const REQUEST_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const API_ERRORS = {
  DEFAULT: 'Something went wrong',
  NETWORK: 'No internet connection. Please check your network and try again',
  TIMEOUT: 'The request timed out. Please try again',
  SURVEY_COMPLETED: 'You have already completed this survey',
};

export const API_ERROR_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
};

export const API_ERROR_CODES = {
  USER_INACTIVE: 'user_inactive',
  UNAUTHORIZED_ACCESS: 'UNAUTHORIZED_ACCESS',
  ORGANISATION_ARCHIVED: 'ORGANISATION_ARCHIVED',
  ORGANISATION_DELETED: 'ORGANISATION_DELETED',
};
